module.exports = new __parcel__URL__("dashboards-directory-app-skeleton.tpl.eb730072.svg").toString();